<template>
    <p-search-screen
        title="Instructors"
        api-destination="instructors"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        add-bulk-is-active-toggle
        :use-bootstrap-selection="false"
        edit-key="instructorId"
        add-new-button
    />
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'InstructorFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: true,
                searchBy: 'All'
            },
            filterBy: ['All', 'Name', 'Email'],
            fields: [
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'email',
                    sortable: true
                },
                {
                    key: 'isActive',
                    sortable: true,
                    disabled: true
                }
            ]
        };
    }
};
</script>
